import axios from 'axios';
import { devBaseUrl, testBaseUrl, proBaseUrl, devQxBaseUrl, testQxBaseUrl, proQxBaseUrl, appid, isQx } from "../common/variable";
import { judgeIsLogin } from '../common/utils';

type config = {
  baseURL: string,
  appid: string
}
// 全局的配置文件
export const Config: config = {
  baseURL: devBaseUrl,
  appid
}

//环境切换 
if (process.env.NODE_ENV === 'development') {
  Config.baseURL = isQx ? devQxBaseUrl : devBaseUrl;
} else if (process.env.NODE_ENV === 'test') {
  Config.baseURL = isQx ? testQxBaseUrl : testBaseUrl;
} else if (process.env.NODE_ENV === 'production') {
  Config.baseURL = isQx ? proQxBaseUrl : testBaseUrl;
  // Config.baseURL = proBaseUrl;
}



// 学院的重定向登陆地址
export const redirectUrl = isQx ? Config.baseURL : `${Config.baseURL}/client/account?appid=${Config.appid}`;
// 学院的接口访问前缀
const xyBaseUrl = Config.baseURL + `/api/switch?appid=${Config.appid}&apiurl=`;
// 
const qxBaseUrl = Config.baseURL;



export const instance = axios.create({
  baseURL: isQx ? qxBaseUrl : xyBaseUrl,
  timeout: 1000 * 50,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    // 'Content-Type': 'multipart/form-data;',
    // 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundary1oYvfFuONlXegpfi'
    // token
  }
});

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    const token = JSON.parse(window.localStorage.getItem("token") || JSON.stringify(null));
    token && (isQx ? config.headers.Token = token : config.headers.token = token);
    isQx && (config.headers.Platform = "QX");
    return config;
  }
);
/**
 * 响应拦截器
 * 每次拦截后
 */
instance.interceptors.response.use(
  (response: any) => {
    // console.log('response', response);
    // if ([0, 1038, 1040, 10000].includes(response.data.code)) {

    if ([401].includes(response.status)) {
      judgeIsLogin();
      return;
    }

    if (response.data.code === 0 || response.data.code) {
      return response;
    } else { // token失效，默认跳转到登陆页面
      // window.location.href = redirectUrl;
      return;
    }
  }
)
